import { RecentTransactionsResp } from 'types/api/response/recent-transactions-resp'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const getRecentTransactions = (count?: number) =>
  api.get<RecentTransactionsResp>('help_center/recent_transactions', {
    params: { count },
    headers: moneyObjectHeader,
  })
